import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import {
  ACCESS_LEVEL_STR,
  isAnyTypeOfGold,
} from 'pages/User/AccessLevel';
import ImageIcon from 'components/ChatMessageTypes/components/ImageIcon';

import fanclubIcon from '../../../../../../../images/fanclub-icon.png';
import goldStar from '../../../../../../../images/user/gold-star.png';

import RecentSpendingTierIndicator from './RecentSpendingTierIndicator';
import styles from './MultiplePrivateChat.css';


const Option = (props) => {
  const {
    accessLevel,
    hasTokens,
    isFanclubSubscribed,
    isRoomModerator,
    label,
    performerTopTipper,
    recentSpendingTier,
  } = props;

  const isGold = isAnyTypeOfGold(accessLevel);
  const isCoach = accessLevel === ACCESS_LEVEL_STR.COACH;
  const roomModeratorIcon = !isCoach && isRoomModerator === '1';
  const isTipLeader = !isCoach && !roomModeratorIcon && performerTopTipper?.toLowerCase() === label?.toLowerCase();

  return (
    <div className={styles.option}>
      <div>
        {isGold && (
          <img alt="gold" className={styles.icon} src={goldStar} />
        )}
        {isFanclubSubscribed === '1' && !isGold && (
          <img alt="fanclub" className={styles.icon} src={fanclubIcon} />
        )}
        {!isCoach && (
          <RecentSpendingTierIndicator
            hasTokens={Boolean(hasTokens)}
            recentSpendingTier={recentSpendingTier}
          />
        )}
      </div>
      <div>
        {label}
      </div>
      <div>
        {isCoach && (
          <span className={styles.coach}>
            {translate('v2profile.chat.coach')}
          </span>
        )}
        {roomModeratorIcon && (
          <span className={styles.mod}>
            {translate('v2profile.chat.mod')}
          </span>
        )}
        {isTipLeader && (
          <ImageIcon type="crown" />
        )}
      </div>
    </div>
  );
};

Option.propTypes = {
  accessLevel: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  hasTokens: PropTypes.number,
  isFanclubSubscribed: PropTypes.string,
  isRoomModerator: PropTypes.string,
  performerTopTipper: PropTypes.string,
  recentSpendingTier: PropTypes.number,
};

Option.defaultProps = {
  hasTokens: 0,
  isFanclubSubscribed: '0',
  performerTopTipper: '',
  isRoomModerator: '0',
  recentSpendingTier: undefined,
};

export default Option;
